/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Content Explorer
 *| (C) Copyright IBM Corp. 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([
	'react',
	'mobx-react',
	'@ba/ba-ui-carbon',
	'prop-types'
], function(
	React,
	MobxReact,
	BA_UI_CARBON,
	PropTypes
) {

	const getUISpec = (props) => {
		const { item } = props;
		let spec = item;
		if (item && item.editor && item.editor.uiControl) {
			spec = item.editor.uiControl;
		}
		return spec;
	};

	class ToggleButton extends React.Component {

		render() {
			const { style, className } = this.props;
			return (
				<div style={style} className={className}>
					{this.renderControl()}
				</div>
			);
		}

		renderControl() {
			const { item } = this.props;

			const { setPropertyValue, getPropertyValue } = item;
			const { id, label, readOnly } = getUISpec(this.props);

			return (
				<React.Fragment>
					<div className="ToggleButton--label">{label}</div>
					<BA_UI_CARBON.ToggleSmall
						id={id}
						labelA={null}
						labelB={null}
						onToggle={(value) => {
							setPropertyValue(value);
						}}
						toggled={getPropertyValue()}
						disabled={readOnly}
					/>
				</React.Fragment>
			);
		}
	}

	ToggleButton.propTypes = {
		item: PropTypes.shape({
			editor: PropTypes.shape({
				uiControl: PropTypes.shape({
					id: PropTypes.string,
					label: PropTypes.string,
					readOnly: PropTypes.bool
				})
			}),
			id: PropTypes.string.isRequired,
			label: PropTypes.string.isRequired,
			readOnly: PropTypes.bool,
			setPropertyValue: PropTypes.func.isRequired,
			getPropertyValue: PropTypes.func.isRequired
		}),
		style: PropTypes.object,
		className: PropTypes.string
	};
	ToggleButton.defaultProps = {};

	return MobxReact.observer(ToggleButton);
});